module.exports = __webpack_public_path__ + "assets/img/center-layer-2-dfafc2c1.png";